<template>
	<div
		v-editable="blok"
		class="grid items-start"
		:class="
			isColumnView
				? 'grid-cols-1 gap-4'
				: 'md:place-items-center md:grid-cols-3 gap-12 my-12 main-wrapper'
		"
	>
		<StoryblokComponent
			v-for="feature in blok.content"
			:key="feature._uid"
			:blok="feature"
		/>
	</div>
</template>

<script setup lang="ts">
import type { BlokColumns } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokColumns;
	isColumnView?: boolean;
}

const { blok, isColumnView } = defineProps<Props>();
</script>
